<div class="ngx-flag-picker-container">
	<mat-form-field class="thin-outline-input-field flag-picker-dropdown" subscriptSizing="dynamic">
		<mat-select
			disableOptionCentering
			panelClass="thin-outline-select-panel flag-picker-select-panel"
			(selectionChange)="changeSelectedCountryCode($event.value)"
			(openedChange)="toggleFlipArrow()"
			(closedChange)="toggleFlipArrow()"
			[value]="selectedCountryCode"
			[ngClass]="{ 'flip-mat-select-arrow': flipArrow, 'thin-outline-input-disabled': isDisabled }"
			data-automation-id="country-code-picker"
			[disabled]="isDisabled"
		>
			@for (code of countryCodes; track code) {
				<mat-option [value]="code" [attr.data-automation-id]="'country-code-' + code">
					{{ getCountryLabel(code) }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
